import { render, staticRenderFns } from "./ProductLss.vue?vue&type=template&id=c38f8616"
import script from "./ProductLss.vue?vue&type=script&lang=js"
export * from "./ProductLss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports